fragment NumberedImageFragment on numberedImage_Entry {
  typeHandle
  index
  alt
  body
  image {
    ...CraftAssetFragment
  }
  autoplay
}
